import { MobileDataService } from "utils/enums/MobileDataEnums";
import { TopupCreateItemRequestModel } from "./TopupCreateItemRequestModel";

export class TopupCreateRequestModel {
  service?: MobileDataService;
  travelSimMobileData?: TopupCreateItemRequestModel;
  ecommerceSimMobileData?: TopupCreateItemRequestModel;
  mobileData?: TopupCreateItemRequestModel;

  constructor(service: MobileDataService, item: TopupCreateItemRequestModel) {
    this.service = service;
    switch (service) {
      case MobileDataService.SimEcommerce:
        this.ecommerceSimMobileData = item;
        break;
      case MobileDataService.TravelSim:
        this.travelSimMobileData = item;
        break;
      case MobileDataService.BuyPackage:
        this.mobileData = item;
        break;
      default:
    }
  }
}
